import { Grid } from '@mui/material'
import NavBar from './NavBar'
import HomeSC from './HomeSC'
import { AboutSC } from './AboutSC'
import Ehr from './Ehr'
import { PageEnder } from './PageEnder'
import { UpcomingEvents } from './UpcomingEvents'
// import CountDown from './CountDown'
// import Modal from 'react-modal'
// import AccessBox from './AccessBox'

export default function Starter() {

  return (
    <Grid 
    container
    position="relative"
    width="100%"
    height="100%"  
    >

    {/* Backgroynd Image */}
     <div
      style={{
        backgroundImage:"radial-gradient(130% 100% at 0% 0%, #737373, #0C8645)"
      }}
      
      className='absolute h-[100%] w-full overflow-hidden'
      />
    {/* Backgroynd Image */}


      {/* Nav Bar */}
       <NavBar />
      
      {/* Home page */}
      <HomeSC />

      {/* About Page */}
      <AboutSC />

      {/* More about ehr */}
      <div id='ehr'>
      <Ehr />
      </div>
      

      {/* Upcoming Events Section */}
      <UpcomingEvents />

      {/* 501c3 tab / instag */}
      <PageEnder />

    </Grid>
      
  )
}
